import { LOCALE_ID, NgModule } from '@angular/core'
import { CommonModule, registerLocaleData } from '@angular/common'
import { blockWhiteSpaceDirective } from './block-whitespace.directive'
import { ValidNameDirective } from './valid-name.directive'
import { CsSelectOptionsDirective } from './cs-select-options.directive'
import { AddressSelectorDirective } from './address-selector.directive'
import { CsSelectOptionsCustomDirective } from '../component/cs-select-table/directives/cs-select-options.directive'
import { AddressCustomSelectorDirective } from '../component/cs-select-table/directives/cs-address-selector.directive'
import { NumberCommaDirective } from './number-comma.directive'
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe);

const directives = [
  blockWhiteSpaceDirective,
  ValidNameDirective,
  CsSelectOptionsDirective,
  AddressSelectorDirective,
  CsSelectOptionsCustomDirective,
  AddressCustomSelectorDirective,
  NumberCommaDirective
]
@NgModule({
  imports: [CommonModule],
  declarations: [
    ...directives
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'de-DE' }
  ],
  exports: [
    ...directives
  ],
})
export class DirectivesModule {
}
